import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const CreditTerms = () => {
  const dealerName = 'Paradise-Performance';

  return (
    <div className="min-h-screen bg-gray-50 pt-24 lg:pt-32">
      <Helmet>
        <title>Credit Application Terms | {dealerName}</title>
        <meta name="description" content="Read our credit application conditions of use, privacy notice and electronic communications policy before submitting your finance application." />
        <link rel="canonical" href="https://paradise-performance.com/credit-terms" />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="max-w-3xl mx-auto px-4 pb-16">
        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">

          <h1 className="text-3xl font-bold text-gray-900 mb-6">Conditions of Use</h1>

          <p className="text-gray-700 mb-6">
            Welcome to our online store! {dealerName} and its associates provide their services to you subject to the following conditions. By continuing on to the website, you accept these conditions. Please read them carefully.
          </p>

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-8">
            <p className="text-yellow-800 font-bold text-lg">
              THIS TRANSACTION IS NOT AN APPLICATION FOR CREDIT
            </p>
          </div>

          {/* Privacy */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-900 mb-3">Privacy</h2>
            <p className="text-gray-700">
              Please review our{' '}
              <Link to="/privacy" className="text-blue-600 hover:text-blue-800 underline">
                Privacy Notice
              </Link>
              , which also governs your visit to our website, to understand our practices.
            </p>
          </section>

          {/* Electronic Communications */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-900 mb-3">Electronic Communications</h2>
            <p className="text-gray-700">
              When you visit {dealerName} or send e-mails to us, you are communicating with us electronically. You consent to receive communications from us electronically. We will communicate with you by e-mail or by posting notices on this site. You agree that all agreements, notices, disclosures and other communications that we provide to you electronically satisfy any legal requirement that such communications be in writing.
            </p>
          </section>

          {/* Copyright */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-900 mb-3">Copyright</h2>
            <p className="text-gray-700">
              All content included on this site, such as text, graphics, logos, button icons, images, audio clips, digital downloads, data compilations and software, is the property of {dealerName} or its content suppliers and protected by international copyright laws. The compilation of all content on this site is the exclusive property of {dealerName}, with copyright authorship for this collection by {dealerName} and protected by international copyright laws.
            </p>
          </section>

          {/* Trade Marks */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-900 mb-3">Trade Marks</h2>
            <p className="text-gray-700">
              {dealerName} trademarks and trade dress may not be used in connection with any product or service that is not {dealerName}'s, in any manner that is likely to cause confusion among customers, or in any manner that disparages or discredits {dealerName}. All other trademarks not owned by {dealerName} or its subsidiaries that appear on this site are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by {dealerName} or its subsidiaries.
            </p>
          </section>

          {/* License and Site Access */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-900 mb-3">License and Site Access</h2>
            <p className="text-gray-700 mb-4">
              {dealerName} grants you a limited license to access and make personal use of this site. The license does not grant you the right to download (other than page caching) or modify the content, or any portion of it, except with express written consent of {dealerName}. This license does not include any resale or commercial use of this site or its contents: any collection and use of any product listings, descriptions or prices: any derivative use of this site or its contents: any downloading or copying of account information for the benefit of another merchant: or any use of data mining, robots or similar data gathering and extraction tools.
            </p>
            <p className="text-gray-700 mb-4">
              This site or any portion of this site may not be reproduced, duplicated, copied, sold, resold, visited or otherwise exploited for any commercial purpose without express written consent of {dealerName}. You may not frame or utilize framing techniques to enclose any trademark, logo or other proprietary information (including images, text, page layout or form) of {dealerName} and our associates without express written consent. You may not use any meta tags or any other "hidden text" utilizing {dealerName}'s name or trademarks without the express written consent of {dealerName}.
            </p>
            <p className="text-gray-700">
              Any unauthorized use terminates the permission or license granted by {dealerName}. You are granted a limited, revocable and nonexclusive right to create a hyperlink to the home page of {dealerName} so long as the link does not portray {dealerName}, its associates or their products or services in a false, misleading, derogatory or otherwise offensive matter. You may not use any {dealerName} logo or other proprietary graphic or trademark as part of the link without express written permission.
            </p>
          </section>

          {/* Back Link */}
          <div className="mt-10 pt-6 border-t border-gray-200 text-center">
            <Link
              to="/finance-application"
              className="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
            >
              Return to Finance Application
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditTerms;
